import { SingleShippingEmissionEstimate } from '@lune-climate/lune'
import { SuccessResponseWithMeta } from '@lune-climate/lune/esm/core/SuccessResponse'
import { Leg } from '@lune-fe/lune-components-lib'
import { FC } from 'react'

import SingleLegEstimate from 'views/CalculateEmissions/Logistics/SingleLegEstimate'
import MultiLegEstimate from 'views/CalculateEmissions/MultiLegLogistics/MultiLegEstimate'

interface ShippingEstimateDetailsProps {
    estimate: SuccessResponseWithMeta<SingleShippingEmissionEstimate>
    resolvedLegs: Leg[]
}

export const ShippingEstimateDetails: FC<ShippingEstimateDetailsProps> = ({
    estimate,
    resolvedLegs,
}) => {
    if (resolvedLegs.length) {
        return (
            <MultiLegEstimate
                legs={resolvedLegs}
                load={estimate.request.shipment}
                meta={estimate._meta}
                source={'source' in estimate ? estimate.source : undefined}
            />
        )
    }

    return <SingleLegEstimate estimate={estimate} />
}
